export default __webpack_public_path__ + "f0ff2e2fb1076c4e3ab246a26372ed71.svg";